import { getItem } from '../../helpers/webStorage';
import { Action, ListerData, ListerStorageStateKey } from '../../types';
import filterFacets from './listerHelper';
import mediaQuery from '../../helpers/mediaQuery';
import { isIphone } from '../../helpers/browserHelpers';

export enum ListerActionTypes {
  SET_LISTER_RESULTS = 'SET_LISTER_RESULTS',
  APPEND_LISTER_RESULTS = 'APPEND_LISTER_RESULTS',
  PREPEND_LISTER_RESULTS = 'PREPEND_LISTER_RESULTS',
  REVERT_LISTER_RESULTS = 'REVERT_LISTER_RESULTS',
  SET_LISTER_DISABLED = 'SET_LISTER_DISABLED',
  SET_IS_FACETS_MODAL_DISPLAYED = 'SET_IS_FACETS_MODAL_DISPLAYED',
  SET_IS_BIGGER_IMAGES_DISPLAYED = 'SET_IS_BIGGER_IMAGES_DISPLAYED'
}

export type ListerAction = Action<ListerActionTypes>;

export interface ListerState extends Omit<ListerData, 'categoryCode'> {
  isListerDisabled: boolean;
  isFacetsModalDisplayed: boolean;
  isBiggerImagesSelected: boolean;
}

function listerReducer(prevState: ListerState = computeInitialState(), action: Action<ListerActionTypes>): ListerState {
  switch (action.type) {
    case ListerActionTypes.SET_LISTER_RESULTS: {
      return {
        ...prevState,
        rid: action.rid,
        pagination: action.pagination,
        breadcrumbs: action.breadcrumbs,
        results: action.results,
        sorts: action.sorts,
        currentQuery: action.currentQuery,
        facets: filterFacets(action),
        previousFacets: [...prevState.facets],
        previousResults: [...prevState.results],
        isListerDisabled: false
      };
    }
    case ListerActionTypes.APPEND_LISTER_RESULTS: {
      return {
        ...prevState,
        rid: action.rid,
        pagination: action.pagination,
        breadcrumbs: action.breadcrumbs,
        results: [...prevState.results, ...action.results],
        sorts: action.sorts,
        currentQuery: action.currentQuery,
        facets: filterFacets(action),
        previousFacets: [...prevState.facets],
        previousResults: [...prevState.results],
        isListerDisabled: false
      };
    }
    case ListerActionTypes.PREPEND_LISTER_RESULTS: {
      return {
        ...prevState,
        rid: action.rid,
        pagination: action.pagination,
        breadcrumbs: action.breadcrumbs,
        results: [...action.results, ...prevState.results],
        sorts: action.sorts,
        currentQuery: action.currentQuery,
        facets: filterFacets(action),
        previousFacets: [...prevState.facets],
        previousResults: [...prevState.results],
        isListerDisabled: false
      };
    }
    case ListerActionTypes.REVERT_LISTER_RESULTS: {
      return {
        ...prevState,
        facets: [...prevState.previousFacets],
        results: [...prevState.previousResults],
        isFacetsModalDisplayed: mediaQuery.isSmallOnly() || isIphone() ? false : prevState.isFacetsModalDisplayed
      };
    }
    case ListerActionTypes.SET_LISTER_DISABLED: {
      return {
        ...prevState,
        isListerDisabled: action.isListerDisabled
      };
    }
    case ListerActionTypes.SET_IS_FACETS_MODAL_DISPLAYED: {
      return {
        ...prevState,
        isFacetsModalDisplayed: action.isFacetsModalDisplayed
      };
    }
    case ListerActionTypes.SET_IS_BIGGER_IMAGES_DISPLAYED: {
      return {
        ...prevState,
        isBiggerImagesSelected: action.isBiggerImagesSelected
      };
    }
    default: {
      return prevState;
    }
  }
}

function computeInitialState(): ListerState {
  const {
    listerData: initialListerState,
    isBiggerImagesSelected,
    isPlpFilterExpanded,
    plpPriceSliderStyle,
    rolexCollectionLinks
  } = window.globalLister;
  const {
    pagination: { sort },
    sorts
  } = initialListerState;
  const initialSort = sort ?? sorts.find((option) => option.selected)?.code ?? '';

  const state = {
    ...initialListerState,
    plpPriceSliderStyle,
    rolexCollectionLinks,
    isListerDisabled: false,
    isFacetsModalDisplayed: !mediaQuery.rolexGlobal.isLargeUp() || isIphone() ? false : isPlpFilterExpanded,
    isBiggerImagesSelected:
      getItem(ListerStorageStateKey.IS_BIGGER_IMAGES_SELECTED) ?? (isBiggerImagesSelected || false)
  };

  state.pagination.sort = initialSort;
  return state;
}

export default listerReducer;
